module["exports"] = [
  "Nederland"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/address/default_country.js
 ** module id = 807
 ** module chunks = 0
 **/